var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnabledEmailSelector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 61,
    viewBox: "0 0 75 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H71C73.2091 0 75 1.79086 75 4V57C75 59.2091 73.2091 61 71 61H4C1.79086 61 0 59.2091 0 57V4Z",
    fill: "#4155EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1075 17.4286H23.9646C22.1673 17.4286 20.7131 18.654 20.7131 20.1518L20.6968 36.4911C20.6968 37.9889 22.1673 39.2143 23.9646 39.2143H50.1075C51.9048 39.2143 53.3754 37.9889 53.3754 36.4911V20.1518C53.3754 18.654 51.9048 17.4286 50.1075 17.4286ZM50.1075 22.875L37.0361 29.6831L23.9646 22.875V20.1518L37.0361 26.9598L50.1075 20.1518V22.875Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnabledEmailSelector);
export default __webpack_public_path__ + "static/media/enabled-email-selector.917b8102123bce4a8794d67580459af8.svg";
export { ForwardRef as ReactComponent };